export default "__VITE_ASSET__DSSvf6i6__"